'use strict';

/** @type {import('./reflectApply')} */
module.exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;



//////////////////
// WEBPACK FOOTER
// ./~/_call-bind-apply-helpers@1.0.2@call-bind-apply-helpers/reflectApply.js
// module id = 1244
// module chunks = 0